import { RefreshCw } from 'lucide-react'
import { Button } from '@/components/ds2'

interface BoxTruckRefreshControlsProps {
    canRefresh: boolean
    hideLaneFilters: boolean
    loading: boolean
    onRefresh: () => void
    className?: string
}

/** Shared refresh action for both the full filters and their collapsed toolbar. Keeping one rendering path
 * ensures hiding the editable fields never removes the control that operates the current result set.
 * Renders nothing when there is no button to show — the wrapper is a full-width flex row, so an empty one
 * would claim a line of the toolbar. */
export const BoxTruckRefreshControls = ({ canRefresh, hideLaneFilters, loading, onRefresh, className = '' }: BoxTruckRefreshControlsProps) => {
    if (!canRefresh || !hideLaneFilters) return null

    return (
        <div className={`flex flex-wrap items-center gap-x-3 gap-y-2 min-[900px]:flex-nowrap ${className}`}>
            <Button variant="secondary" size="sm" disabled={loading} onClick={onRefresh} prefix={<RefreshCw size={16} />} className="ml-auto shrink-0">
                <span className="min-[900px]:hidden">Refresh</span>
                <span className="hidden min-[900px]:inline">Refresh Feed</span>
            </Button>
        </div>
    )
}
